import React from "react"
import { HeaderTertiary } from "@fedsim/components"

let localStorageSize = function () {
  let _lsTotal = 0, _xLen, _x;
  for (_x in localStorage) {
    if (!localStorage.hasOwnProperty(_x)) continue;
    _xLen = (localStorage[_x].length + _x.length) * 2;
    _lsTotal += _xLen;
  }
  return (_lsTotal / 1024).toFixed(2);
}

export function SaveSize({ Wrapper = HeaderTertiary }) {

  return (
    <Wrapper>
      Filesize: {localStorageSize()}kb
    </Wrapper>
  )
}
export default SaveSize
